import React from "react";
import { useSelector } from 'react-redux';

const Coordinates = ({ krazki }) => {
    const squares = useSelector((state) => state.squaresState);
    const parseJsonToCoordinates = (mata) => {
        const squaresState = mata.data;
        let disks = [];
        const dictionary = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
        for (let i = 0; i < 10; i++) {
            for (let j = 0; j < 10; j++) {
                const disk = squaresState[i][j];
                if (disk.startsWith('z')) {
                    if (disks.some(({ id }) => id === disk)) {
                        disks = disks.map(element => element.id === disk ? { ...element, positions: [...element.positions, dictionary[j] + i] } : element)
                    }
                    else {
                        disks.push({ id: disk, positions: [dictionary[j] + i] });
                    }
                }
            }
        }

        return disks;
    }

    const getImageFromId = (id) => {
        const disk = krazki.find((krazek) => krazek.id === id);

        return disk.path;
    }

    const parsePosition = (position) => `${position[0]}${+position[1] + 1}`

    return (
        <div className="coordinates">
            {squares && parseJsonToCoordinates(squares).map(coordinate => (
                <div key={coordinate.id} className="d-flex color-white mb-1">
                    <div
                        className="cell-content cell-content-menu without-border-radius flex-shrink-0 mr-1"
                        style={{ backgroundImage: `url(/akademia/image/krazki/${getImageFromId(coordinate.id)})` }}>
                    </div>
                    <div className="d-flex flex-wrap">
                        {coordinate.positions.sort().map(state =>
                            <p key={state} style={{ fontSize: "18px", margin: "0 0 0 4px", lineHeight: "1" }}>
                                {parsePosition(state)}
                            </p>
                        )}
                    </div>
                </div>
            ))}
        </div>
    )
}

export default Coordinates;


// WEBPACK FOOTER //
// ./src/Coordinates/Coordinates.js